<router-outlet></router-outlet>

<p-confirmDialog appendTo="body" icon="fa fa-question-circle" [style]="{width: '425px'}"></p-confirmDialog>

<wsd-global-messages [life]="4000"></wsd-global-messages>
